import React, { useMemo } from "react";
import { getUrlParamValue } from "@/utils";
import IconDark from "@/assets/net_offline_dark.png";
import IconLight from "@/assets/net_offline_light.png";

const NetError = () => {
  const _isDarkTheme = useMemo(() => {
    const theme = getUrlParamValue(location.href, "theme");
    return theme == "0";
  }, []);

  return (
    <div style={{ textAlign: "center", paddingTop: "15vh" }}>
      <img style={{ width: "200px" }} src={_isDarkTheme ? IconDark : IconLight} alt="" />
    </div>
  );
};

export default NetError;
